import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/material.css'; // starts close to MUI look
import {
  Box,
  FormControl,
  InputLabel,
  FormHelperText
} from "@mui/material";

export default function PhoneField({
  label = "Phone",
  defaultCountry = "tr",
  error = false,
  helperText = "",
  required = false,
  fullWidth = true,
  value = "",
  onChange = () => {},
}) {
  return (
    <FormControl fullWidth required={required} variant="outlined">
        <InputLabel
            shrink
            sx={{
                backgroundColor: 'transparent',
                px: 0.5, // little horizontal padding so text doesn’t touch border
            }}
        >
            {label}
        </InputLabel>
      <Box
        sx={{
          // target react-phone-input-2 classes to match MUI Outlined
          ".react-tel-input .special-label": {
            display: "none !important",
          },
          ".react-tel-input .form-control": {
            width: "100%",
            height: 56,
            paddingLeft: "52px !important",
            paddingRight: 1,
            borderRadius: 1,
            background: "transparent",
            borderColor: (t) => t.palette.mode === "light" ? "rgba(0,0,0,0.23)" : "rgba(255,255,255,0.23)",
            "&:hover": {
              borderColor: (t) => t.palette.text.primary,
            },
            "&:focus": {
              borderWidth: 2,
              borderColor: (t) => t.palette.primary.main,
              boxShadow: "none",
            },
          },
          ".react-tel-input .flag-dropdown": {
            border: "none",
            borderRight: (t) => `1px solid ${t.palette.divider}`,
            borderRadius: "4px 0 0 4px",
            background: "transparent",
          },
          ".react-tel-input .selected-flag": {
            borderRadius: "4px 0 0 4px",
            "&:hover": { background: "transparent" },
          },
          ...(error && {
            ".react-tel-input .form-control": {
              borderColor: (t) => t.palette.error.main,
            },
          }),
        }}
      >
        <PhoneInput
          fullWidth
          country={defaultCountry}     // e.g. "tr"
          value={value}
          onChange={onChange}
          enableSearch
          inputProps={{
            name: "phone",
            autoComplete: "tel",
            required,
          }}
          // optional: class hooks if you prefer CSS files instead of sx()
          containerClass="phone-container"
          inputClass="phone-input"
          buttonClass="phone-flag"
          dropdownClass="phone-dropdown"
        />
        <FormHelperText>{helperText}</FormHelperText>
      </Box>
    </FormControl>
  );
}
